











import { Component, Vue } from 'vue-property-decorator';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

@Component({})
export default class FetchingBar extends Vue {
  private status = {
    shown: false,
    numberOfAjaxCAllPending: 0
  };

  created() {
    const { status } = this;
    axios.interceptors.request.use(
      (config: AxiosRequestConfig) => {
        if (config.method === 'POST' || config.method === 'post') {
          status.numberOfAjaxCAllPending += 1;
          Vue.set(status, 'shown', true);
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    axios.interceptors.response.use(
      (response: AxiosResponse<any>) => {
        if (response?.config?.method === 'post' || response?.config?.method === 'POST')
          status.numberOfAjaxCAllPending -= 1;

        if (status.numberOfAjaxCAllPending === 0) {
          status.shown = false;
        }
        return response;
      },
      (error) => {
        status.numberOfAjaxCAllPending -= 1;
        if (status.numberOfAjaxCAllPending === 0) {
          status.shown = false;
        }
        return Promise.reject(error);
      }
    );
  }
}
